import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const FingerPrintIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12 3.36C13.94 3.36 16.3 3.84 18.12 4.88L17.48 6.34C15.88 5.42 14.02 4.96 12 4.96C9.98 4.96 8.12 5.42 6.52 6.34L5.88 4.88C7.7 3.84 10.06 3.36 12 3.36ZM12 6.72C15.7 6.72 19 8.52 21.16 11.72L19.82 12.6C18 9.84 15.22 8.32 12 8.32C8.78 8.32 6 9.84 4.18 12.6L2.84 11.72C5 8.52 8.3 6.72 12 6.72ZM12 10.08C15.9 10.08 19.04 12.92 19.56 16.88L17.98 17.08C17.56 13.92 15.08 11.68 12 11.68C8.92 11.68 6.44 13.92 6.02 17.08L4.44 16.88C4.96 12.92 8.1 10.08 12 10.08ZM12 13.44C14.4 13.44 16.36 15.4 16.36 17.78V19.6H14.72V17.78C14.72 16.28 13.5 15.04 12 15.04C10.5 15.04 9.28 16.28 9.28 17.78V19.6H7.64V17.78C7.64 15.4 9.6 13.44 12 13.44ZM12.82 20.68H11.18V17.62C11.18 17.16 11.54 16.8 12 16.8C12.46 16.8 12.82 17.16 12.82 17.62V20.68Z" />
    </SvgIcon>
  );
});
